import * as Yup from 'yup';
import passwordValidationRules from '@nexxt/common/firebase/auth/passwordValidation';
import axios from 'axios';

export function getSignupValidationSchema() {
    return Yup.object().shape({
        ...passwordValidationRules,
        email: Yup.string()
            .email('Please enter a valid email address.')
            .trim()
            .required('Please enter a valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            )
            .matches(
                /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!live.com)(?!outlook.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/,
                `Please enter a corporate email address`
            )
            .test('Unique Email', 'Email is already in use', async (value) => {
                try {
                    if (value) {
                        const emailValidationResponse = await axios.post(
                            `${process.env.INCA_SERVER_URL}/auth/validateEmail`,
                            { email: value }
                        );
                        if (emailValidationResponse.status === 200) {
                            return true;
                        }
                        return false;
                    }
                    return false;
                } catch (err) {
                    return false;
                }
            }),
        lastName: Yup.string()
            .trim()
            .required('Please enter your last name.')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            ),
        firstName: Yup.string()
            .trim()
            .required('Please enter your first name.')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            ),
        company: Yup.string()
            .trim()
            .required('Please enter your company.')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            ),
        url: Yup.string()
            .trim()
            .required('Please enter account url.')
            .matches(/^[A-Za-z.\s_0-9-]+$/, `You can't use special symbols.`)
            .test(
                'Unique URL',
                'URL is unavailable. Please, try another URL',
                async (value) => {
                    try {
                        if (value) {
                            const urlValidationResponse = await axios.post(
                                `${process.env.INCA_SERVER_URL}/auth/validateUrl`,
                                { url: value }
                            );
                            console.log(urlValidationResponse);
                            if (urlValidationResponse.status === 200) {
                                return true;
                            }
                            return false;
                        }
                        return false;
                    } catch (err) {
                        return false;
                    }
                }
            )
    });
}

export function getSignupWithInvitationValidationSchema() {
    return Yup.object().shape({
        ...passwordValidationRules,
        lastName: Yup.string().trim().required('Please enter your last name.'),
        firstName: Yup.string()
            .trim()
            .required('Please enter your first name.'),
        company: Yup.string().trim().required('Please enter your company.')
    });
}

export function getLoginValidationSchema() {
    return Yup.object().shape({
        password: Yup.string()
            .trim()
            .min(4, 'Your password must contain atleast 4 characters.')
            .required('Please enter password.'),
        email: Yup.string()
            .email('Please enter valid email address.')
            .trim()
            .required('Please enter valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            )
    });
}

export function forgotPasswordValidationSchema() {
    return Yup.object().shape({
        email: Yup.string()
            .email('Please enter valid email address.')
            .trim()
            .required('Please enter valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            )
    });
}

export function resetPasswordValidationSchema() {
    return Yup.object().shape({
        ...passwordValidationRules
    });
}
